// extracted by mini-css-extract-plugin
export default {"downContainer":"ScrollButton_downContainer__7CGOw","arrowButton":"ScrollButton_arrowButton__qQL78","downText":"ScrollButton_downText__ZzqYV"};